// LabelField.js
import React from "react";
import { Field } from "formik";

const CatalogLabelField = ({ element, values, name, tableName, tdkeys }) => {
  if (element.prefix === "CAT" && element.catalogueSchemaType === 7) {
    return (
      <Field
        as="label"
        id={`${tableName}[${tdkeys}].${name}`}
        type="label"
        name={`${tableName}[${tdkeys}].${name}`}
        //value={values?.[tableName]?.[tdkeys]?.[name]}
        data-testid="CatalogLabelField"
      >
        {values?.[tableName]?.[tdkeys]?.[name]}
      </Field>
    );
  }
  return null;
};

export default CatalogLabelField;
